module.exports = __webpack_public_path__ + "account/img/274.670c42ee.png";